(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["escala-brand-story"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-escala-lens]').forEach((area) => {
    const lens = area.querySelector('.escala-story__lens');
    const image = area.querySelector('img');
    if (!lens || !image) return;
    const updateLens = (clientX, clientY) => {
      const rect = area.getBoundingClientRect();
      const x = Math.max(0, Math.min(clientX - rect.left, rect.width));
      const y = Math.max(0, Math.min(clientY - rect.top, rect.height));
      const naturalWidth = image.naturalWidth || rect.width;
      const naturalHeight = image.naturalHeight || rect.height;
      const coverScale = Math.max(rect.width / naturalWidth, rect.height / naturalHeight);
      const renderedWidth = naturalWidth * coverScale;
      const renderedHeight = naturalHeight * coverScale;
      const cropX = (renderedWidth - rect.width) / 2;
      const cropY = (renderedHeight - rect.height) / 2;
      const zoom = 2;
      const lensRadius = lens.offsetWidth / 2;
      lens.style.left = `${x}px`;
      lens.style.top = `${y}px`;
      lens.style.backgroundSize = `${renderedWidth * zoom}px ${renderedHeight * zoom}px`;
      lens.style.backgroundPosition = `${lensRadius - (x + cropX) * zoom}px ${lensRadius - (y + cropY) * zoom}px`;
      lens.classList.add('is-active');
    };
    area.addEventListener('pointermove', (event) => updateLens(event.clientX, event.clientY));
    area.addEventListener('pointerleave', () => lens.classList.remove('is-active'));
    area.addEventListener('touchstart', (event) => {
      const touch = event.touches[0];
      if (touch) updateLens(touch.clientX, touch.clientY);
    }, { passive: true });
    area.addEventListener('touchmove', (event) => {
      const touch = event.touches[0];
      if (touch) updateLens(touch.clientX, touch.clientY);
    }, { passive: true });
    area.addEventListener('touchend', () => lens.classList.remove('is-active'), { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
